/**
 * This module  mainly exists to avoid circular imports.
 * Please [colocate](https://kentcdodds.com/blog/colocation) your query keys / factories.
 */
import { UUID } from 'ComponentLibrary/src/common/uuid'

const THREADS_KEY = 'THREADS'
export const CREATE_MESSAGE_KEY = 'CREATE_MESSAGE'

export const THREAD_KEYS = {
    all: [THREADS_KEY],
    order: (orderId: UUID) => [THREADS_KEY, 'ORDER', orderId],
    single: (threadId: UUID, orderId: UUID) => [...THREAD_KEYS.order(orderId), 'THREAD', threadId],
}
